import React from 'react';
import TreasuryOperationsView from "./TreasuryOperationsView"
function TreasuryOperations(props) {
    return (
       <TreasuryOperationsView/>
       );
}

export default TreasuryOperations;
